// NOTE: AUTO GENERATED FILE! Do not modify directly!

export enum BreakpointsValuesEnum {
  'small' = 0,
  'medium' = 600,
  'tabletportrait' = 768,
  'large' = 1024,
  'xlarge' = 1200,
  'xxlarge' = 1440
}
